/* eslint-disable max-lines */
import { ModalState } from 'kinetic-angular';
import { registrationPageData } from '../../constants/registration';
import { CssClass, Icons, ModalButtonId } from '../../services/shared/shared-enums';
import { LocationList, RegistrationState, SubmitBusinessPayload, UploadFileLabels } from './definitions';
import { SharedFactoryDataService } from '../../services/shared/shared-factory-data.service';

export class RegistrationFactory
{
	public static build(): RegistrationState
	{
		return {
			tempFlag: false,
			tempIsPrefilled: false,
			crmPrefill: false,
			firstName: '',
			lastName: '',
			companyDetails: {
				addressLine1: '',
				addressLine2: '',
				companyName: '',
				state: '',
				zipCode: '',
				city: '',
				country: ''
			},
			phoneNumber: '',
			jobTitle: [{
				label: '',
				id: ''
			}],
			requestedRole: [{
				description: '',
				id: '',
				name: ''
			}],
			accountName: '',
			addressDetails: {
				addressLine1: '',
				addressLine2: '',
				city: '',
				state: '',
				country: '',
				zipCode: ''
			},
			email: '',
			profileInformation: {
				firstName: '',
				lastName: '',
				phoneNumber: '',
				jobTitle: [{
					label: '',
					id: ''
				}],
				requestedRole: [{
					description: '',
					id: '',
					name: ''
				}],
				email: ''
			},
			submitButton: {
				size: 'large',
				style: 'primary',
				disabled: true,
				label: 'Submit Registration',
				position: 'none',
				icon: {
					altText: '',
					iconPath: ''
				}
			},
			verifyInformationButton: {
				size: 'large',
				style: 'primary',
				disabled: false,
				label: '',
				position: 'none',
				icon: {
					altText: '',
					iconPath: ''
				}
			},
			modifyDetailsButton: {
				size: 'large',
				style: 'secondary',
				disabled: false,
				label: '',
				position: 'none',
				icon: {
					altText: '',
					iconPath: ''
				}
			},
			continueButton: {
				size: 'large',
				style: 'primary',
				disabled: true,
				label: '',
				position: 'none',
				icon: {
					altText: '',
					iconPath: ''
				}
			},
			termsAgreeButton: {
				size: 'medium',
				style: 'primary',
				disabled: true,
				label: 'Agree',
				position: 'none',
				icon: {
					altText: '',
					iconPath: ''
				}
			},
			policyAgreeButton: {
				size: 'medium',
				style: 'primary',
				disabled: true,
				label: 'Agree',
				position: 'none',
				icon: {
					altText: '',
					iconPath: ''
				}
			},
			termsModal: {
				hidden: true,
				label: 'Terms And Conditions',
				buttons: [
					{
						label: 'Agree',
						cssClass: CssClass.btnBlack,
						disabled: true
					}
				],
				cssClass: CssClass.registerModal
			},
			policyModal: {
				hidden: true,
				label: 'Privacy Policy',
				buttons: [
					{
						label: 'Agree',
						cssClass: CssClass.btnBlack,
						disabled: true
					}
				],
				cssClass: CssClass.registerModal
			},
			disagreeButton: {
				size: 'medium',
				style: 'secondary',
				disabled: false,
				label: 'Disagree',
				position: 'none',
				icon: {
					altText: '',
					iconPath: ''
				}
			},
			contactDealerButton: {
				size: 'large',
				style: 'secondary',
				disabled: false,
				label: '',
				position: 'right',
				icon: {
					altText: '',
					iconPath: Icons.externalLink
				}
			},
			footer: {
				cssClass: '',
				ribbonImage: '',
				altText: '',
				footercontent: {
					css: {
						ecomm: ''
					},
					script: {},
					unifiedFooter: '',
					fixed: false,
					hidden: false,
					logoImagePath: '',
					altText: '',
					footermenu: SharedFactoryDataService.getFooterMenuDefault(),
					copyright: {
						label: '',
						labelUrl: [
							{
								label: '',
								url: ''
							},
							{
								label: '',
								url: ''
							},
							{
								label: '',
								url: ''
							},
							{
								label: '',
								url: ''
							}
						]
					}
				}
			},
			registrationPage: registrationPageData,
			dealerInfo: {
				address: '',
				dealerName: '',
				email: '',
				phoneNumber: ''
			},
			loading: true,
			vertexAPIValidationLabels: {
				description: '',
				editAddressLabel: '',
				heading: '',
				useVerifiedLabel: ''
			},
			mapVertexAddressFailedLabels: {
				description: '',
				editAddressLabel: '',
				heading: ''
			},
			mapVerifyRoleLabels: {
				description: '',
				dropdownLabel: '',
				note: ''
			},
			errorText: {
				invalidCharacterWithNumericErrorMessage: '',
				requiredErrorMessage: '',
				requiredDropdownErrorMessage: '',
				minLengthZipCodeError: '',
				canadaPostalCodeFormatError: '',
				phoneLength: '',
				phoneSameNumber: '',
				phoneSequenceNumber: ''
			},
			additionalLocationList: {
				primaryLocationInfo: {
					primaryLocationGRID: '',
					adminLocationID: '',
					topLevelGrid: '',
					companyName: '',
					addressLine1: '',
					addressLine2: '',
					city: '',
					state: '',
					zipCode: '',
					country: ''
				},
				locationList: [
					{
						locationGRID: '',
						companyName: '',
						addressLine1: '',
						city: '',
						state: '',
						zipCode: '',
						country: ''
					}
				],
				pendingLocationDetails: {
					originalFileName: '',
					updatedFileName: ''
				  }
			},
			additionalLocationGridHeaderDesktop: [],
			additionalLocationGrid: [
				{
					locationGRID: '',
					companyName: '',
					address: '',
					country: '',
					checked: false
				}
			],
			additionalLocationError: {
				message: '',
				messageSubText: '',
				icon: ''
			},
			ribbonClearButton: {
				size: 'medium',
				style: 'link',
				disabled: false,
				label: 'Clear All',
				icon: {
					altText: '',
					iconPath: ''
				},
				position: 'none'
			},
			additionalLocationSubmitButton: {
				size: 'large',
				style: 'primary',
				disabled: false,
				label: 'Submit',
				position: 'none',
				icon: {
					altText: '',
					iconPath: ''
				}
			},
			businessRegistrationFlowSubmitModalLabels: {
				heading: '',
				closeIcon: {
					iconPath: '',
					altText: ''
				},
				cancel: '',
				proceed: ''
			},
			uploadFileSection: this.businessRegistrationUploadListLabel()
		};
	}
	public static businessRegistrationUploadListLabel(): UploadFileLabels
	{
		return {
			heading: '',
			subHeading: '',
			content: [
				{
					label: '',
					description: ''
				}
			],
			closeIcon: { iconPath: '', altText: '' },
			download: {
				downloadButton: '',
				errorMessage: ''
			},
			cancel: '',
			upload: '',
			close: '',
			uploadFile: {
				onLoadIcon: { iconPath: '', altText: '' },
				errorIcon: { iconPath: '', altText: '' },
				successIcon: { iconPath: '', altText: '' },
				dragDropLabel: '',
				orLabel: '',
				uploadButtons: {
					chooseFile: '',
					replaceFile: '',
					tryAgain: ''
				},
				success: ''
			},
			errorState:
				{
					messages: [],
					id: '',
					statusCode: 500,
					image: {
						iconPath: '',
						altText: ''
					}
				}
		};
	}
	public static businessRegistrationUploadListModal(): ModalState
	{
		return {
			hidden: true,
			label: '',
			buttons: [
				{ label: '', disabled: false, cssClass: CssClass.btnSecondary, id: ModalButtonId.cancel },
				{ label: '', disabled: false, cssClass: CssClass.btnBlack, id: '' },
				{ label: '', disabled: false, cssClass: CssClass.btnSecondary, id: ModalButtonId.close }
			],
			cssClass: CssClass.businessRegistrationUploadModal
		};
	}
	public static buildDefaultTranslationValuesMap(): Map<string, string>
	{
		return new Map<string, string>([
			[ 'United States- English', 'en' ],
			[ 'États-Unis - anglais', 'en' ],
			[ 'French', 'fr' ],
			[ 'Français', 'fr' ]
		]);
	}
	public static buildCompanyDetails(): { accountName: string; addressLine1: string; addressLine2: string; country: string; city: string; state: string; postalCode: string }
	{
		return {
			accountName: '',
			addressLine1: '',
			addressLine2: '',
			country: '',
			city: '',
			state: '',
			postalCode: ''
		};
	}
	public static buildSubmitLocationsPayload(selectedGrids: LocationList[]): SubmitBusinessPayload
	{
		return {
			selectedLocationList: selectedGrids,
			selectionMethod: 'manual',
			claimDomain: false
		};
	}
	public static buildSubmitUploadFileLocationsPayload(): SubmitBusinessPayload
	{
		return {
			selectedLocationList: [],
			selectionMethod: 'document',
			claimDomain: false
		};
	}
	public static businessRegistrationFlowSubmitModal(): ModalState
	{
		return {
			hidden: true,
			label: '',
			buttons: [
				{ label: '', disabled: false, cssClass: CssClass.btnSecondary, id: ModalButtonId.cancel },
				{ label: '', disabled: false, cssClass: CssClass.btnBlack, id: ModalButtonId.proceed }
			],
			cssClass: CssClass.businessRegistrationSubmitModalTitle
		};
	}
	public static verifyAddressModal(): ModalState
	{
		return {
			hidden: true,
			label: '',
			buttons: [
				{ label: '', disabled: false, cssClass: CssClass.btnSecondary, id: ModalButtonId.close },
				{ label: '', disabled: false, cssClass: CssClass.btnBlack, id: ModalButtonId.proceed }
			],
			cssClass: CssClass.vertexVerificationModal
		};
	}
}
